module.exports = function kwToHp(kw) {
  var hp = Math.round(kw / 0.73549875);
  var finalConvert = kw + "kW (" + hp + "PS)";
  return finalConvert;
};
